export const getRoleDisplayName = (role: string): string => {
  const roleTranslations: { [key: string]: string } = {
    'ADMIN': 'Administrator',
    'MANAGER': 'Manager',
    'ACCOUNTING': 'Buchhaltung', 
    'EMPLOYEE': 'Mitarbeiter'
  };
  
  return roleTranslations[role.toUpperCase()] || role;
};

export const getRoleDescription = (role: string): string => {
  const roleDescriptions: { [key: string]: string } = {
    'ADMIN': 'Vollzugriff auf alle Funktionen und Benutzerverwaltung',
    'MANAGER': 'Verwaltung von Mitarbeitern und Berichten',
    'ACCOUNTING': 'Einsicht in Arbeitszeiten und Urlaubsverwaltung',
    'EMPLOYEE': 'Zeiterfassung und eigene Daten verwalten'
  };
  
  return roleDescriptions[role.toUpperCase()] || 'Unbekannte Rolle';
};

export const getAllRoles = () => [
  { value: 'ADMIN', label: 'Administrator', description: 'Vollzugriff auf alle Funktionen und Benutzerverwaltung' },
  { value: 'MANAGER', label: 'Manager', description: 'Verwaltung von Mitarbeitern und Berichten' },
  { value: 'ACCOUNTING', label: 'Buchhaltung', description: 'Einsicht in Arbeitszeiten und Urlaubsverwaltung' },
  { value: 'EMPLOYEE', label: 'Mitarbeiter', description: 'Zeiterfassung und eigene Daten verwalten' }
];
